import React from 'react';
import cx from 'classnames';

interface SkipLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {}

const SkipLink: React.FC<SkipLinkProps> = ({ className, href = '#content', ...props }) => {
  return (
    <a
      href={href}
      className={cx(
          'yst-absolute yst-left-[10px] yst-z-[100000] yst-block yst-h-12 yst-min-w-[150px] yst-px-[15px] yst-text-[14px] yst-leading-[48px] yst-bg-[var(--bg-color-white)] yst-rounded yst-shadow-md yst-underline yst-text-center yst-outline-none; yst--top-[1000em] focus:yst-top-[10px] focus:yst-text-[var(--text-color-blue)]',
          className
      )}
      {...props}
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;
